export default "__VITE_ASSET__DI2RqIS0__"